import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
//require ('tui-time-picker/dist/tui-time-picker.css');
//require ('tui-date-picker/dist/tui-date-picker.css');
//require ("tui-calendar/dist/tui-calendar.css");
//require ("tui-time-picker/dist/tui-time-picker.js");  
//require ("tui-date-picker/dist/tui-date-picker.js");  
//import Calendar from "tui-calendar";

export default class extends ApplicationController {
    static targets = ["hm0_output"];

    connect() {
        console.log("planning_conges JS en cours ...");
        super.connect();
        // add your code here, if applicable
    }

    afterShowConges(event) {
        $("#dates_form_submit").click();
    }

    afterShowArretsTravails(event) {
        $("#dates_form_submit").click();
    }

    afterShowTeletravails(event) {
        $("#dates_form_submit").click();
    }

    afterShowFormations(event) {
        $("#dates_form_submit").click();
    }
    
    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
  /*calendar = new Calendar(document.getElementById('calendar'), {
        id: "1",
        name: "Mon calendrier",
        defaultView: 'month',
        color: '#00a9ff',
          bgColor: '#00a9ff',
          dragBgColor: '#00a9ff',
          borderColor: 'red',
        disableClick: true,
        milestone: true,    // Can be also ['milestone', 'task']
        scheduleView: true,  // Can be also ['allday', 'time']
        useCreationPopup: true,
        useDetailPopup: true,
        template: {
        milestone: function(schedule) {
            return '<span style="color:red;"><i class="fa fa-flag"></i> ' + schedule.title + '</span>';
        },
        milestoneTitle: function() {
            return 'Milestone';
        },
        task: function(schedule) {
            return '&nbsp;&nbsp;#' + schedule.title;
        },
        taskTitle: function() {
            return '<label><input type="checkbox" />Task</label>';
        },
        allday: function(schedule) {
            return schedule.title + ' <i class="fa fa-refresh"></i>';
        },
        alldayTitle: function() {
            return 'All Day';
        },
        time: function(schedule) {
            return schedule.title + ' <i class="fa fa-refresh"></i>' + schedule.start;
        },
        monthMoreTitleDate: function(date) {
            date = new Date(date);
            return tui.util.formatDate('MM-DD', date) + '(' + daynames[date.getDay()] + ')';
        },
        monthMoreClose: function() {
            return '<i class="fa fa-close"></i>';
        },
        monthGridHeaderExceed: function(hiddenSchedules) {
            return '<span class="calendar-more-schedules">+' + hiddenSchedules + '</span>';
        },
        monthGridFooterExceed: function(hiddenSchedules) {
            return '<span class="calendar-footer-more-schedules">+ See ' + hiddenSchedules + ' more events</span>';
        },
        weekDayname: function(dayname) {
            return '<span class="calendar-week-dayname-name">' + dayname.dayName + '</span><br><span class="calendar-week-dayname-date">' + dayname.date + '</span>';
        },
        monthDayname: function(dayname) {
            return '<span class="calendar-week-dayname-name">' + dayname.label + '</span>';
        },
        timegridDisplayPrimaryTime: function(time) {
            var meridiem = time.hour < 12 ? 'am' : 'pm';

            return time.hour + ' ' + meridiem;
        },
        timegridDisplayTime: function(time) {
            return time.hour + ':' + time.minutes;
        },
        goingDuration: function(model) {
            var goingDuration = model.goingDuration;
            var hour = parseInt(goingDuration / SIXTY_MINUTES, 10);
            var minutes = goingDuration % SIXTY_MINUTES;

            return 'GoingTime ' + hour + ':' + minutes;
        },
        comingDuration: function(model) {
            var goingDuration = model.goingDuration;
            var hour = parseInt(goingDuration / SIXTY_MINUTES, 10);
            var minutes = goingDuration % SIXTY_MINUTES;

            return 'ComingTime ' + hour + ':' + minutes;
        },
        popupDetailRepeat: function(model) {
            return model.recurrenceRule;
        },
        popupDetailBody: function(model) {
            return model.body;
        }
        },
        month: {
            daynames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            startDayOfWeek: 0,
            narrowWeekend: true
        },
        week: {
            daynames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            startDayOfWeek: 0,
            narrowWeekend: true
        }
    });
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    this.createCalendarSchedule();
    this.updatedCalendarSchedule();
    this.deleteCalendarSchedule();
  }

  next(){
    console.log( calendar.getDateRangeEnd().getTime().format(' MM.DD'))
    this.calendar.next();
  }
  prev(){
    this.calendar.prev();
  }

  createCalendarSchedule(){
    let calendar = this.calendar
    calendar.on('beforeCreateSchedule', function(event) {
      var triggerEventName = event.triggerEventName;
      var schedule =  {
        id: 1,
        calendarId: '1',
        title: event.title,
        category: 'time',
        location: event.location,
        start: event.start,
        end: event.end
      }
      if (triggerEventName === 'click') {
          // open writing simple schedule popup
          // schedule = {...};
      } else if (triggerEventName === 'dblclick') {
          // open writing detail schedule popup
          // schedule = {...};
      }
      calendar.createSchedules([schedule]);
      let formData = new FormData()
      formData.append('title', schedule.title);
      formData.append('category', schedule.category);
      formData.append('start', schedule.start._date);
      formData.append('end', schedule.end._date);
      formData.append('location', schedule.location);
      //Rails.ajax({
      //  type: "POST",
      //  url: '/schedules',
      //  data: formData
      //});
    });
  } 
  updatedCalendarSchedule(){
    let calendar = this.calendar
        calendar.on('beforeUpdateSchedule', function(event) {
          var schedule = event.schedule;
          var changes = event.changes;
          var formUpdate = new FormData()    
          if (changes.end) {
          formUpdate.append("end", changes.end._date)    
          }
          if (changes.start) {
          formUpdate.append("start", changes.start._date)    
          }
          if (changes.title) {
          formUpdate.append("title", changes.title)  
          }
          if (changes.category) {
          formUpdate.append("category", changes.category)  
          }
          calendar.updateSchedule(schedule.id, schedule.calendarId, changes);

          //Rails.ajax({
          //type: "PATCH",
          //url: '/schedules/'+ schedule.id,
          //data: formUpdate
          //})

          });
      }
  deleteCalendarSchedule(){
    let calendar = this.calendar
       calendar.on('beforeDeleteSchedule', function(event) {
          var schedule = event.schedule;
          calendar.deleteSchedule(schedule.id, schedule.calendarId)

          Rails.ajax({
            type: "DELETE",
            url: '/schedules/'+ schedule.id,
          })
          });
      }
  getCalendardata(){
    var schedules = JSON.parse(document.querySelector("#calendar").dataset.schedules);
    window.schedules = schedules;
    schedules.forEach(schedule => {
      this.calendar.createSchedules([
        {
          id: schedule.id,
          calendarId: '1',
          title: schedule.title,
          category: 'time',
          dueDateClass: schedule.dueDateClass,
          location: schedule.location,
          start: schedule.start,
          end: schedule.end
        }
      ])
    });
  }
  */
}